import {
    createValidationResult,
    createFailure,
    FailureSeverity,
    ValidationResult,
    validationSuccessful
} from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { OrderListingItem } from "../OrderListingItem";

export const validateOrder = (item: OrderListingItem): ValidationResult => {
    if (statusesNotAllowedToSelectVideo.includes(item.status)) {
        return createValidationResult([
            createFailure(
                `Cannot select video if order has status ${OrderStatus[item.status]}`,
                "wrong-order-status",
                FailureSeverity.Warning
            )
        ]);
    }

    return validationSuccessful();
};

export const statusesNotAllowedToSelectVideo = [
    OrderStatus.Approved,
    OrderStatus.DeliveryApproved,
    OrderStatus.DeliveryCompleted
];
